import { GetAllAgenciesResponseBodyType } from "@intelligems/ig-types/functions/agencies";
import { adminKeys } from "@src/api/queryKeys";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { api } from "../api";

const getAllAgencies = async () => {
  const resp =
    await api.get<GetAllAgenciesResponseBodyType>(`/v2/admin/agencies`);
  return resp.data;
};

export const useGetAgencies = (): UseQueryResult<
  GetAllAgenciesResponseBodyType,
  Error
> => {
  return useQuery<GetAllAgenciesResponseBodyType, Error>({
    queryKey: adminKeys.agencies,
    queryFn: async () => getAllAgencies(),
  });
};
